import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Fleet Offers</h3>
                <p className="text-sm text-gray-600">
                    Discover exclusive deals and promotions for fleet-related services.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Browsing Offers</h4>
                <p className="text-sm text-gray-600">
                    View a grid of current offers from approved partners, including fuel discounts, tire promotions, and service bundles. Click on any offer to see more details.
                </p>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Relevance</h4>
                <p className="text-sm text-gray-600">
                    These offers are curated based on your fleet's activity and location to help you reduce operational costs.
                </p>
            </section>
        </div>
    );
};

export default Help;
